/** KISA 「패스워드 선택 및 이용 안내서」 권고 요약 (테넌트 정책으로 강화될 수 있음) */
export function PasswordHint() {
  return (
    <ul className="text-xs text-slate-500 mb-3 list-disc pl-4 space-y-0.5">
      <li>영문 대·소문자, 숫자, 특수문자 중 3종 이상 조합 8자 이상 (2종이면 10자 이상)</li>
      <li>연속·반복 문자(1234, abcd, aaaa, qwer)와 이메일·이름 등 개인정보 포함 불가</li>
      <li>유출된 것으로 알려진 비밀번호와 최근 사용한 비밀번호 불가</li>
    </ul>
  );
}
